module.exports = __webpack_public_path__ + "static/img/n_email.8de8f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/n_email.png
// module id = /PIC
// module chunks = 0